import { Inject, Injectable, Injector } from '@angular/core';

import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.FootPrintPortalManager = this.injector.get(FootPrintPortalManager_ReportService);
  }
    public FootPrintPortalManager: FootPrintPortalManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

